/* eslint-disable deprecation/deprecation */
export { Console } from './console';
export { Http } from './http';
export { OnUncaughtException } from './onuncaughtexception';
export { OnUnhandledRejection } from './onunhandledrejection';
export { Modules } from './modules';
export { ContextLines } from './contextlines';
export { Context } from './context';
export { RequestData } from '@sentry/core';
export { LocalVariables } from './local-variables';
export { Undici } from './undici';
export { Spotlight } from './spotlight';
export { Anr } from './anr';
export { Hapi } from './hapi';
